import React from 'react';
import { ThreadedItemReply } from '@dreamai/types';
import { ReactComponent as EditIcon } from '../../icons/edit.svg';
import { generateMessageColors } from './sidebar/threadUtils';
import './reply-item.scss';

interface ReplyItemProps {
  reply: ThreadedItemReply;
  formatReplyTime: (timestamp: string) => string;
  agentPredominantColour?: string;
  smallWidth?: boolean;
}

/**
 * Reusable component for displaying a single reply
 */
const ReplyItem: React.FC<ReplyItemProps> = ({
  reply,
  formatReplyTime,
  agentPredominantColour,
  smallWidth = false,
}) => {
  const isUser = reply.from === 'User';

  // Generate agent colors if this is an agent reply and we have a predominant color
  const agentColors =
    !isUser && agentPredominantColour
      ? generateMessageColors(agentPredominantColour)
      : null;

  return (
    <div
      className={`reply-item ${isUser ? 'reply-from-user' : 'reply-from-agent'} ${smallWidth ? 'small-width' : ''}`}
      style={
        agentColors
          ? {
              background: agentColors.background,
              borderColor: agentColors.borderColor,
            }
          : undefined
      }
    >
      {!smallWidth && (
        <div className='icon'>
          <EditIcon />
        </div>
      )}
      <div className='reply-body'>
        <div className='reply-header'>
          From {reply.from_name.split(' ')[0]} (
          {formatReplyTime(reply.created_at)})
        </div>
        <div className='reply-content'>
          {reply.contents.type === 'text' && reply.contents.value}
        </div>
      </div>
    </div>
  );
};

export default ReplyItem;
